const state = {
  styles: {
    bg: {
      blue: 'bg-blue-500',
      red: 'bg-red-500',
      green: 'bg-green-500',
      'cool-gray': 'bg-cool-gray-500',
      valencia: 'bg-valencia-500',
      indigo: 'bg-indigo-500',
      blued: 'bg-blued-500',
      teal: 'bg-teal-500',
      yellow: 'bg-yellow-500',
    },
    bgPage: {
      blue: 'bg-blue-100',
      red: 'bg-red-100',
      green: 'bg-green-100',
      'cool-gray': 'bg-cool-gray-100',
      valencia: 'bg-valencia-100',
      indigo: 'bg-indigo-100',
      blued: 'bg-blued-100',
      teal: 'bg-teal-100',
      yellow: 'bg-yellow-100',
    },
    text: {
      blue: 'text-blue-500',
      red: 'text-red-500',
      green: 'text-green-500',
      'cool-gray': 'text-cool-gray-500',
      valencia: 'text-valencia-500',
      indigo: 'text-indigo-500',
      blued: 'text-blued-500',
      teal: 'text-teal-500',
      yellow: 'text-yellow-500',
    },
    bgDarkest: {
      blue: 'bg-blue-700',
      red: 'bg-red-700',
      green: 'bg-green-700',
      'cool-gray': 'bg-cool-gray-700',
      valencia: 'bg-valencia-700',
      indigo: 'bg-indigo-700',
      blued: 'bg-blued-700',
      teal: 'bg-teal-700',
      yellow: 'bg-yellow-700',
    },
    border: {
      blue: 'text-blue-500',
      red: 'text-red-500',
      green: 'text-green-500',
      'cool-gray': 'text-cool-gray-500',
      valencia: 'text-valencia-500',
      indigo: 'text-indigo-500',
      blued: 'text-blued-500',
      teal: 'text-teal-500',
      yellow: 'text-yellow-500',
    }
  }
};


export const style = {
  namespaced: true,
  state,
};